/**
 * Service API pour le module Semaine Promo
 */

import api from "@/api/api";
import type {
  PromoApiResponse,
  PromoBanner,
  PromoCampaign,
  PromoSupplier,
  PromoSupplierDetailResponse,
} from "@/types/promo";

export default {
  /**
   * Récupère les bandeaux actifs pour affichage dans le dashboard
   */
  async getActiveBanners(): Promise<PromoBanner[]> {
    const response = await api.get<PromoApiResponse<PromoBanner[]>>(
      "/v1/promo/active-banners"
    );
    return response.data.data;
  },

  /**
   * Récupère les informations de la campagne Semaine Promo active
   */
  async getCampaign(): Promise<PromoCampaign> {
    const response = await api.get<PromoApiResponse<PromoCampaign>>(
      "/v1/promo"
    );
    return response.data.data;
  },

  /**
   * Récupère la liste des fournisseurs participants
   * @param brandFilter - Filtre optionnel par marque (fendt, valtra, hv)
   */
  async getSuppliers(brandFilter?: string): Promise<PromoSupplier[]> {
    const params = brandFilter ? { brand: brandFilter } : {};
    const response = await api.get<PromoApiResponse<PromoSupplier[]>>(
      "/v1/promo/suppliers",
      { params }
    );
    return response.data.data;
  },

  /**
   * Récupère le détail d'un fournisseur + ses offres
   * @param supplierId - ID du fournisseur
   * @param brandFilter - Filtre optionnel par marque (fendt, valtra, hv)
   */
  async getSupplierDetail(
    supplierId: number,
    brandFilter?: string
  ): Promise<PromoSupplierDetailResponse> {
    const params = brandFilter ? { brand: brandFilter } : {};
    const response = await api.get<
      PromoApiResponse<PromoSupplierDetailResponse>
    >(`/v1/promo/suppliers/${supplierId}`, { params });
    return response.data.data;
  },

  /**
   * Télécharge un fichier d'offre
   * @param offerId - ID de l'offre
   */
  downloadOffer(offerId: number): void {
    const baseUrl = import.meta.env.VITE_API_URL || "http://agco.test:8000";
    window.location.href = `${baseUrl}/api/v1/promo/offers/${offerId}/download`;
  },

  /**
   * Récupère l'URL de visualisation d'un fichier PDF
   * @param offerId - ID de l'offre
   */
  getOfferViewUrl(offerId: number): string {
    const baseUrl = import.meta.env.VITE_API_URL || "http://agco.test:8000";
    return `${baseUrl}/api/v1/promo/offers/${offerId}/view`;
  },
};
